import BlockQuote from "@tiptap/extension-blockquote";
import Bold from "@tiptap/extension-bold";
import BulletList from "@tiptap/extension-bullet-list";
import Code from "@tiptap/extension-code";
import CodeBlock from "@tiptap/extension-code-block";
import Document from "@tiptap/extension-document";
import HardBreak from "@tiptap/extension-hard-break";
import Heading from "@tiptap/extension-heading";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Image from "@tiptap/extension-image";
import Italic from "@tiptap/extension-italic";
import Link from "@tiptap/extension-link";
import ListItem from "@tiptap/extension-list-item";
import OrderedList from "@tiptap/extension-ordered-list";
import Paragraph from "@tiptap/extension-paragraph";
import Strike from "@tiptap/extension-strike";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextExtension from "@tiptap/extension-text";
import Underline from "@tiptap/extension-underline";
import { generateHTML } from "@tiptap/html";
import { Text } from "@wojo/ui";
import { useMemo } from "react";
import { JSONContent } from "@tiptap/core";

export const TipTap: React.FC<{ json?: JSONContent | null }> = ({ json }) => {
    const output = useMemo(() => {
        if (!json) {
            return null;
        }
        return generateHTML(json, [
            BlockQuote,
            BulletList,
            CodeBlock,
            Document,
            HardBreak,
            Heading,
            HorizontalRule,
            Image,
            ListItem,
            OrderedList,
            Paragraph,
            Table,
            TableCell,
            TableHeader,
            TableRow,
            TextExtension,
            Bold,
            Italic,
            Strike,
            Link,
            Code,
            Underline,
        ]);
    }, [json]);

    if (output === null) {
        return null;
    }

    return (
        <Text.Body tag="div">
            <div dangerouslySetInnerHTML={{ __html: output }}></div>
        </Text.Body>
    );
};
